import jobsTeaser from './jobs-teaser';


export default (di) => {
	di
		.setType({type: jobsTeaser, name: 'JobsTeaser', parent: 'PageComponent'})
	;
};
